import file from '../../store/config/file';
import api from '../../store/config/api';
import { FILE as SCHEMA, FILE_LIST as SCHEMA_LIST } from '../../schemas';
import qs from 'querystring';
import context from '../../util/context';

export const [
  GET_FILE_OBJECT,
  GET_FILE_OBJECT_REQUEST,
  GET_FILE_OBJECT_SUCCESS,
  GET_FILE_OBJECT_FAILURE
] = api.buildTypes('GET_FILE_OBJECT');

export function getFileObject({ teamName, fileID }) {
  return {
    type: GET_FILE_OBJECT,
    payload: {
      url: `/teams/${teamName}/files/${fileID}`,
      schema: SCHEMA
    }
  };
}

export const [
  GET_FILE,
  GET_FILE_REQUEST,
  GET_FILE_SUCCESS,
  GET_FILE_FAILURE
] = file.buildTypes('GET_FILE');

export function getFile({ teamName, fileID }) {
  return {
    type: GET_FILE,
    payload: {
      url: `/teams/${teamName}/files/${fileID}`,
      schema: SCHEMA
    }
  };
}

export const [
  ADD_FILE,
  ADD_FILE_REQUEST,
  ADD_FILE_SUCCESS,
  ADD_FILE_FAILURE
] = file.buildTypes('ADD_FILE');

export function addFile({ teamName, files = [], params = {} }) {
  let url = `/teams/${teamName}`;
  const processID = params.processID || params.processName;
  if (params.runID) {
    url += `/runs/${params.runID}`;
    if (params.taskName) {
      url += `/tasks/${params.taskName}`;
    }
  } else if (processID) {
    url += `/processes/${processID}`;
    if (params.stepName) {
      url += `/steps/${params.stepName}`;
    }
  }
  url += `/files`;

  if (!files.length) throw new Error('File add must be called with files');

  // form data gets saved after the run is saved
  // this preps the files for saving as formData.
  const formData = files.reduce((f, file) => {
    f.append('files[]', file, file.name);
    return f;
  }, new context.FormData());

  return {
    type: ADD_FILE,
    payload: {
      json: false,
      url: params ? `${url}?${qs.stringify(params)}` : url,
      schema: SCHEMA_LIST,
      options: {
        method: 'POST',
        body: formData
      }
    }
  };
}

export const [
  DELETE_FILE,
  DELETE_FILE_REQUEST,
  DELETE_FILE_SUCCESS,
  DELETE_FILE_FAILURE
] = file.buildTypes('DELETE_FILE');

export function deleteFile({ teamName, fileID }) {
  return {
    type: DELETE_FILE,
    payload: {
      url: `/teams/${teamName}/files/${fileID}`,
      schema: SCHEMA,
      options: {
        method: 'DELETE'
      }
    }
  };
}



// WEBPACK FOOTER //
// ./js/actions/api/file.js